<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <b-modal header-bg-variant="info"
             header-text-variant="light"
             ref="confirmModal"
             title="Επιβεβαίωση ενέργειας"
             ok-only
             @ok="updateBookStatement">
      Επιλέξατε {{updateBookLabel.toLowerCase()}} βιβλίου. Θέλετε να συνεχίσετε?
    </b-modal>

    <div class="loading-parent">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"></loading>
    </div>

    <book-info-modal ref="bookInfoModal" :bookDto="bookDtoData" :bookCovers="bookCoversObj"></book-info-modal>

    <b-container>
      <b-button class="float-right"
                variant="outline-info"
                @click="backNavigate"
                style="margin: 5px 5px 5px 20px;">Αρχική
      </b-button>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-btn block href="#" v-b-toggle.accordion variant="info">Στοιχεία Φοιτητή</b-btn>
        </b-card-header>
        <b-collapse id="accordion" accordion="my-accordion" role="tabpanel" visible>
          <b-card-body>
            <small>
              <table class="table table-sm">
                <tbody>
                <tr>
                  <td class="fit">
                    <li><b><i>Επώνυμο:</i></b></li>
                  </td>
                  <td>{{lastname}}</td>
                  <td class="fit">
                    <li><b><i>Ίδρυμα:</i></b></li>
                  </td>
                  <td>{{institution}}</td>
                </tr>

                <tr>
                  <td class="fit">
                    <li><b><i>Όνομα:</i></b></li>
                  </td>
                  <td>{{firstname}}</td>
                  <td class="fit">
                    <li><b><i>Σχολή:</i></b></li>
                  </td>
                  <td>{{school}}</td>
                </tr>
                <tr>
                  <td class="fit">
                    <li><b><i>Α.Μ.:</i></b></li>
                  </td>
                  <td>{{am}}</td>
                  <td class="fit">
                    <li><b><i>Τμήμα:</i></b></li>
                  </td>
                  <td>{{department}}</td>
                </tr>
                </tbody>
              </table>
            </small>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-container>

    <hr/>

    <b-container-fluid>
      <div style="margin-bottom: 4px;" v-if="deliveredToday">
        <b-form inline>
          <b-button variant="warning"
                    @click="printReceipt"
                    size="sm">
            Απόδειξη Παραλαβής
          </b-button>
          &nbsp;&nbsp;
          <small>Εκτύπωση της απόδειξης παραλαβής για όσα βιβλία παραδόθηκαν στον συγκεκριμένο φοιτητή
            <strong><i>σήμερα</i></strong>
          </small>
        </b-form>
      </div>

      <div>
        <small>
          <b-table head-variant="light"
                   small
                   bordered
                   hover
                   ref="table"
                   :items="items"
                   :fields="fields">

            <template slot="books" slot-scope="data">
              <a href="#" @click="bookInfoModal(data.item.bookDto)">
                {{data.item.books}}
              </a>
            </template>

            <template slot="delivered" slot-scope="data">
              <table style="margin: 0.5em;">
                <tr>
                  {{data.item.delivered}}
                </tr>
                <tr>
                  {{data.item.deliverCode}}
                </tr>
                <tr>
                  {{data.item.deliverDate}}
                </tr>
              </table>
            </template>

            <template slot="action" slot-scope="data">
              <b-button size="sm" :variant="data.item.variantBtn" @click="confirm(data)">{{data.item.labelBtn}}</b-button>
            </template>
          </b-table>
        </small>
      </div>
    </b-container-fluid>

  </div>
</template>

<script>

  import BookInfoModal from './BookInfoModalComponent';
  import requests, {GlobalEudoxusBus} from "../../js/DistributionRequestService";
  import Utils from "../../js/AppUtilities";

  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';

  const ACTION_DELIVER = "deliverAction";
  const ACTION_CANCEL = "cancelAction";

  export default {
    name: "book-list-component",
    data() {
      return {
        isLoading: false,
        fullPage: true,
        receiverIdentification: '',
        pin: '',
        componentTag: 'bookList',
        deliveredToday: false,
        firstname: '',
        lastname: '',
        fathername: '',
        institution: '',
        school: '',
        rowData: null,
        updateBookLabel: '',
        department: '',
        am: '',
        bookDtoData: '',
        bookCoversObj: {},
        fields: [
          {key: 'books', label: 'Βιβλία', sortable: true, 'class': 'text-left'},
          {key: 'delivered', label: 'Κατάσταση', sortable: true, 'class': 'text-left'},
          {key: 'action', label: 'Ενέργειες'}
        ],
        items: [],
        showModal: false
      }
    },
    components: {
      'bookInfoModal': BookInfoModal,
      'loading': Loading
    },
    methods: {
      backNavigate() {
        this.$emit('toggleView', 'deliveryFormComponent');
        this.$destroy();
      },
      printReceipt() {
        if (this.pin.length != null && this.receiverIdentification != null)
          requests.getSubmitFileDownload('deliveryReceipt', '', '', '', this.pin);
      },
      studentViewSetup(student) {
        this.firstname = student.firstname;
        this.lastname = student.lastname;
        this.fathername = student.fathername;
        this.institution = student.institution;
        this.school = student.school;
        this.department = student.department;
        this.am = student.am;
      },
      bookListViewSetup(booksArray) {
        this.items = [];
        let start = new Date().setHours(0, 0, 0, 0);
        let end = new Date().setHours(23, 59, 59, 999);

        this.deliveredToday = false;

        for (let i = 0; i < booksArray.length; i++) {
          let book = booksArray[i].book;
          let fullTitle = Utils.bookTitleSummary(book.title, book.type, book.volumeNumber, book.authors, book.publicationYear, book.editorialHouse, book.isbn);
          let bookStatus;
          let actionStatus;
          let labelBtn;
          let variantBtn;
          let deliverCode;
          let deliverDate;

          if (booksArray[i].delivered) {
            variantBtn = "warning";
            bookStatus = "Έχει παραδοθεί";
            deliverCode = "Κωδ.παρ:" + booksArray[i].id;
            deliverDate = new Date(booksArray[i].deliveredDate).getDate() + "/" + (new Date(booksArray[i].deliveredDate).getMonth() + 1) + "/" + new Date(booksArray[i].deliveredDate).getFullYear();
            actionStatus = ACTION_DELIVER;
            labelBtn = 'Επιστροφή';
          } else {
            variantBtn = "primary";
            booksArray[i].status === 'INSERTED' ? bookStatus = 'Προς παράδοση' : bookStatus = 'Έχει επιστραφεί';
            actionStatus = ACTION_CANCEL;
            labelBtn = 'Παράδοση';
          }

          if (booksArray[i].deliveredDate >= start && booksArray[i].deliveredDate <= end)
            this.deliveredToday = true;

          this.items.push({
            books: fullTitle,
            delivered: bookStatus,
            deliverCode: deliverCode,
            deliverDate: deliverDate,
            action: actionStatus,
            labelBtn: labelBtn,
            variantBtn: variantBtn,
            bookDto: book,
            statementBook: booksArray[i]
          });
        }

        this.items.sort(Utils.compareBooks);
      },
      bookInfoModal(data) {
        this.bookDtoData = data;
        let fullPath = "https://static.eudoxus.gr/books/";
        let coverPathImg = fullPath + this.bookDtoData.pathToCover;
        let backCoverPathImg = this.bookDtoData.pathToBackcover;
        this.bookCoversObj = {frontCover: coverPathImg, backCover: backCoverPathImg};

        GlobalEudoxusBus.$emit('toggleBookInfoModal', !this.showModal);
      },
      confirm(data) {
        this.rowData = data;
        this.updateBookLabel = this.rowData.item.labelBtn;
        this.$refs.confirmModal.show();
      },
      updateBookStatement() {
        if (this.rowData != null) {
          this.isLoading = true;
          this.actionBook();
        }
      },
      actionBook() {
        if (this.rowData.item.statementBook.delivered)
          requests.returnBook(this.rowData.item.statementBook.id, this.pin, this.receiverIdentification, this.componentRenderDto);
        else
          requests.deliverBook(this.rowData.item.statementBook.id, this.pin, this.receiverIdentification, this.componentRenderDto);
      },
      componentRenderDto(object) {
        this.isLoading = false;
        if (object != null && object.length !== 0) {
          this.receiverIdentification = object[0].credits[0].receiverIdentification;
          this.pin = object[0].credits[0].pin;
          this.studentViewSetup(object[0].result.student);
          this.bookListViewSetup(object[0].result.books);
        }
      }
    },
    created() {
      GlobalEudoxusBus.$once("bookListComponentRenderDto", object => {
        if (object == null) {
          this.backNavigate();
        } else
          this.componentRenderDto(object);
      });
    }
  }
</script>

<style>
  .table td.fit {
    padding-left: 50px;
    white-space: nowrap;
    width: 1%;
  }

  .table th, .table td {
    vertical-align: middle;
  }

  .loader {
    margin-left: 45%;
    border: 4px solid #324851;
    border-right-color: #fff;
    border-left-color: #fff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
  }

  .loading-parent {
    position: relative;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/BookDeliveryTabComponents/BookListComponent.vue